export default {
  'menu.dashboard': '工作台',
  'menu.login': '登录',
  'menu.users': '用户管理',
  'menu.posts': '帖子管理',
  'menu.official-actions': '官方用户操作',
  'menu.official-actions.workspace': '发帖与互动',
  'menu.official-actions.logs': '自动点赞日志',
  'menu.operations': '运营与互动',
  'menu.operations.checkin-tips': '签到提示语',
  'menu.operations.refresh-tips': '刷新提示词管理',
  'menu.operations.splash': '开屏管理',
  'menu.operations.app-sections': 'APP内板块管理',
  'menu.operations.ip-library': 'IPライブラリ管理',
  'menu.operations.mini-program': '小程序管理',
  'menu.operations.official-notices': '官方通知',
  'menu.operations.tabbar-icons': 'TabBar图标管理',
  'menu.operations.avatar-frames': '头像框管理',
  'menu.operations.stickers': '表情包管理',
  'menu.operations.activities': '活动管理',
  'menu.operations.recommend-banners': '推荐Banner管理',
  'menu.operations.feedback': '反馈中心',
  'menu.operations.points': '积分管理',
  'menu.operations.point-exchanges': '积分兑换管理',
  'menu.market': '小铺管理',
  'menu.market.shops': '小巢审核',
  'menu.market.items': '商品审核',
  'menu.conventions': '漫展管理',
  'menu.conventions.stats': '数据统计',
  'menu.conventions.list': '漫展列表',
  'menu.conventions.orders': '购票订单',
  'menu.conventions.signups': '报名管理',
  'menu.analytics': '数据分析',
  'menu.analytics.stats': '数据统计',
  'menu.analytics.users': '用户分析',
  'menu.analytics.content': '内容分析',
  'menu.analytics.behavior': '行为分析',
  'menu.analytics.growth': '增长留存',
  'menu.system': '系统与权限',
  'menu.system.config': '系统配置',
  'menu.system.push': 'UniPush 明细',
  'menu.system.admins': '管理员管理',
  'menu.system.logs': '操作日志',
};
